import { Phone } from "lucide-react";
import { TAVERN } from "../../data/tavern";

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-[color:var(--pk-border)] bg-[color:var(--pk-bg)]/85 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-8">
        {/* Brand */}
        <a
          href="#top"
          data-testid="brand-link"
          className="flex items-center gap-3 group"
          aria-label="Πρώτο Κατσίκι — Αρχική"
        >
          <span
            aria-hidden="true"
            className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-full"
          >
            <img
              src={TAVERN.logo}
              alt=""
              className="h-full w-full object-contain"
            />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-display text-xl font-black tracking-tight text-[color:var(--pk-text)] md:text-2xl">
              {TAVERN.name}
            </span>
            <span className="hidden text-[11px] uppercase tracking-[0.22em] text-[color:var(--pk-primary)] md:block">
              ΤΑΒΕΡΝΑ · ΚΑΒΑΛΑ
            </span>
          </span>
        </a>

        {/* Nav — desktop */}
        <nav
          aria-label="Κύριο μενού"
          className="hidden items-center gap-8 md:flex"
        >
          <a
            href="#menu"
            data-testid="nav-menu"
            className="text-sm font-semibold uppercase tracking-wider text-[color:var(--pk-text-soft)] transition-colors hover:text-[color:var(--pk-primary)]"
          >
            ΜΕΝΟΥ
          </a>
          <a
            href="#gallery"
            data-testid="nav-gallery"
            className="text-sm font-semibold uppercase tracking-wider text-[color:var(--pk-text-soft)] transition-colors hover:text-[color:var(--pk-primary)]"
          >
            ΓΚΑΛΕΡΙ
          </a>
          <a
            href="#location"
            data-testid="nav-location"
            className="text-sm font-semibold uppercase tracking-wider text-[color:var(--pk-text-soft)] transition-colors hover:text-[color:var(--pk-primary)]"
          >
            ΤΟΠΟΘΕΣΙΑ
          </a>
        </nav>

        {/* Call Now */}
        <a
          href={`tel:${TAVERN.phoneTel}`}
          data-testid="header-call-now-btn"
          className="inline-flex items-center gap-2 rounded-full bg-[color:var(--pk-green)] px-4 py-2.5 text-sm font-bold uppercase tracking-wide text-white shadow-[0_6px_18px_-6px_rgba(60,123,179,0.6)] transition-all hover:-translate-y-0.5 hover:bg-[color:var(--pk-green-dark)] md:px-5 md:py-3"
        >
          <Phone className="h-4 w-4" strokeWidth={2.5} />
          <span className="hidden sm:inline">Call Now</span>
          <span className="sm:hidden">ΚΛΗΣΗ</span>
        </a>
      </div>
    </header>
  );
}
